'use client';

import { analytics } from '@/lib/analytics';
import Link from 'next/link';

const TrackingLink = (props: any) => {
  const { href, from = 'blog_post', cta, ...restProps } = props;
  const isAnchorLink = typeof href === 'string' && href.startsWith('#');
  const onLinkClick = (href: string) => {
    const isDarkglassLink = href.includes('darkglass.com');
    // Consolidated event; `surface` carries what used to live in the event name.
    analytics.capture('link.clicked', { href, isDarkglassLink, cta, surface: from });
  };
  return (
    <Link
      target={isAnchorLink ? undefined : '_blank'}
      className="text-[#40A6FF]"
      rel={isAnchorLink ? undefined : 'noopener noreferrer'}
      onClick={() => onLinkClick(href)}
      href={href}
      {...restProps}
    />
  );
};

export default TrackingLink;
